import * as React from 'react';
import { useState, useRef, useCallback } from 'react';
import type { TooltipInlinePropsType } from './types';

const TooltipInline: React.FC<TooltipInlinePropsType> = ( props ) => {
    const [ visible, setVisible ] = useState( false );
    const tooltipRef = useRef<HTMLDivElement>( null );

    const centerTooltip = useCallback( () => {
        requestAnimationFrame( () => {
            if ( !tooltipRef.current ) {
                return;
            }

            const offset = -( ( tooltipRef.current.offsetHeight - 33 ) / 2 );
            tooltipRef.current.style.marginTop = `${ offset }px`;
        } );
    }, [] );

    const toggleTooltip = useCallback( () => {
        setVisible( ( prev ) => !prev );
    }, [] );

    const hideTooltip = useCallback( () => {
        setVisible( false );
    }, [] );

    let tooltipClass = 'Tooltip Tooltip-info ItemListEntry-tooltip';
    if ( visible ) {
        tooltipClass += ' Tooltip-visible';
        centerTooltip();
    }

    return (
        props.text ? (
            <a
                onClick={ toggleTooltip }
                onBlur={ hideTooltip }
                className='Tooltip-icon'
                tabIndex={ 0 }
            >
                <img src='/static/front/assets/other-icons/info.svg' width='20' height='20' />

                <div className={ tooltipClass } ref={ tooltipRef }>
                    <div className='Tooltip-content'>
                        {props.text}
                    </div>
                </div>
            </a>
        ) : null
    );
};

export { TooltipInline };
